<template>
    <div class="pause w-100 h-100 text-center m-0 p-0">
        <FullScreen btn_class="btn btn-sm btn-outline-light event-icon-btn position-absolute top-0 start-0 m-3 pause-logout" />
        <button type="button" class="btn btn-sm btn-outline-light position-absolute top-0 end-0 m-3 pause-logout" title="Cerrar sesión" @click="logout"><i class="bi bi-box-arrow-left"></i></button>

        <div class="position-fixed w-100 h-100 d-flex justify-content-center align-items-center">
            <div class="d-flex flex-column align-items-center text-center animate__animated animate__fadeIn">
                <i :class="'bi ' + theme.icons.stop + ' pause-icon'"></i>
                <div class="pause-label">{{ theme.texts.stop_reached }}</div>
                <h1 class="pause-title m-0">{{ sector_name || 'Esperando' }}</h1>
                <div class="pause-detail mt-3"><i class="bi bi-circle-fill me-2"></i>Espera al organizador para continuar</div>
            </div>
        </div>
    </div>
</template>

<script>
import FullScreen from '@/components/FullScreen.vue'
import utils from '@/../../shared/utils'
import { get_active_theme } from '@/themes'

// GAME_STATES.PAUSED's own screen - reached whenever active stage playback
// holds at a sector (see server.js's _run_crossed_sectors_then_hold), which
// is now EVERY sector crossed after the mandatory default one, empty or not
// (only S1 alone never holds). Used to have nothing at all here: an empty
// sector left game.state wherever it already was, and Activity.vue's own
// countdown then forced a bogus local guess at RESULT once its clock ran
// out, fighting the server's real state on every broadcast (see
// Activity.vue's update_countdown fix). This is the real, server-driven
// answer to "what does the player see right now".
export default {
    name: 'Pause',
    components: { FullScreen },
    data(){
        return {
            utils: utils,
        };
    },
    computed: {
        theme(){
            return get_active_theme();
        },
        sector_name(){
            return this.$store.state.game.paused_sector_name;
        }
    },
    mounted(){
        if(window.store.state.network == "connected")
            window.network.wso.send(JSON.stringify({action: window.RPC.UPDATE_VIEW, params: {view: window.router.currentRoute._value.name, activity: (window.store.state.game.question) ? window.store.state.game.question.id : null}}))

        $('.modal-backdrop').remove();
    },
    methods: {
        logout(){
            utils.reset_client();
        }
    }
}
</script>

<style scoped>
    .pause{
        user-select: none;
        overflow: hidden;
        position: relative;
        background: radial-gradient(circle at 50% 20%, var(--vc-ink-700), var(--vc-ink-900) 65%);
        color: var(--vc-paper-50);
    }

    .pause-icon{
        font-size: 2.6rem;
        color: var(--vc-accent-500);
        margin-bottom: 12px;
    }

    .pause-label{
        font-family: "Archivo", sans-serif;
        font-weight: 700;
        font-size: 0.9rem;
        text-transform: uppercase;
        letter-spacing: 0.1em;
        color: rgba(255, 255, 255, 0.55);
    }

    .pause-title{
        font-family: "Archivo", sans-serif;
        font-weight: 900;
        font-size: 3vw;
        line-height: 1.15;
        margin-top: 4px;
        color: var(--vc-accent-500);
        text-transform: uppercase;
        letter-spacing: 0.02em;
        text-shadow: 0 4px 28px rgba(0, 0, 0, 0.4);
    }

    .pause-detail{
        font-family: "Archivo", sans-serif;
        font-weight: 800;
        font-size: 1.1rem;
        text-transform: uppercase;
        letter-spacing: 0.02em;
    }
    .pause-detail i{
        font-size: 0.5rem;
        color: var(--vc-accent-500);
        vertical-align: middle;
    }

    .pause-logout{
        z-index: 30;
    }
</style>
